import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import moment from 'moment';


export class InterventionsRequest {
  from: Date;
  to: Date;
  isToday: boolean;

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
  }
}

@Component({
  selector: 'app-interventions-toolbar',
  templateUrl: './interventions-toolbar.component.html',
  styleUrls: ['./interventions-toolbar.component.scss']
})
export class InterventionsToolbarComponent implements OnInit {

  @Input()
  grid: DxDataGridComponent;

  @Output()
  generate = new EventEmitter<InterventionsRequest>();

  generateButtonOptions: any;
  filterChooserButtonOptions: any;
  exportButtonOptions: any;
  request = new InterventionsRequest();
  currentFilter = 2;


  dateFilters: any = [
    {value: 0, label: 'Période Personnalisée'},
    {value: 1, label: 'Dernière heure'},
    {value: 2, label: 'Aujourd\'hui'},
    {value: 3, label: 'Hier'},
    {value: 4, label: 'Avant hier'},
    {value: 5, label: 'Il y a 3 jours'},
    {value: 6, label: 'Cette Semaine'},
    {value: 7, label: 'La Semaine Dernière'},
    {value: 8, label: 'Ce Mois'},
    {value: 9, label: 'Le Mois Dernier'},
  ];

  constructor() {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
    this.dateChanged = this.dateChanged.bind(this);

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: () => {
        this.generate.emit(this.request);
      }
    };

    this.exportButtonOptions = {
      icon: 'xlsxfile',
      text: 'Exporter',
      onClick: () => {
        this.grid.instance.exportToExcel(false);
      }
    };
  }

  ngOnInit(): void {
    this.generate.emit(this.request);
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    switch (e.value) {
      case 0:
        this.request.from = moment().subtract(1, 'years').toDate();
        this.request.to = moment().toDate();
        break;
      case 1:
        this.request.from = moment().subtract(1, 'hours').toDate();
        this.request.to = moment().toDate();
        break;
      case 2:
        this.request.from = moment().startOf('day').toDate();
        this.request.to = moment().endOf('day').toDate();
        this.request.isToday = true;
        break;
      case 3:
        this.request.from = moment().subtract(1, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(1, 'days').endOf('day').toDate();
        break;
      case 4:
        this.request.from = moment().subtract(2, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(2, 'days').endOf('day').toDate();
        break;
      case 5:
        this.request.from = moment().subtract(3, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(3, 'days').endOf('day').toDate();
        break;
      case 6:
        this.request.from = moment().startOf('week').toDate();
        this.request.to = moment().toDate();
        break;
      case 7:
        this.request.from = moment().subtract(1, 'weeks').startOf('week').toDate();
        this.request.to = moment().subtract(1, 'weeks').endOf('week').toDate();
        break;
      case 8:
        this.request.from = moment().startOf('month').toDate();
        this.request.to = moment().toDate();
        break;
      case 9:
        this.request.from = moment().subtract(1, 'months').startOf('month').toDate();
        this.request.to = moment().subtract(1, 'months').endOf('month').toDate();
        break;
    }
  }

  dateChanged(e: any) {
    /*this.currentFilter = 0;
    this.request.isToday = false;*/
  }
}
